import {
CREATE_PAGE_ALIAS_REQUEST, CREATING_PAGE_ALIAS_SUCCEEDED, CREATING_PAGE_ALIAS_FAILED,
FETCH_PAGE_ALIAS_REQUEST, FETCHING_PAGE_ALIAS_SUCCEEDED, FETCHING_PAGE_ALIAS_FAILED,
UPDATE_PAGE_ALIAS_REQUEST, UPDATING_PAGE_ALIAS_SUCCEEDED, UPDATING_PAGE_ALIAS_FAILED,
DELETE_PAGE_ALIAS_REQUEST, DELETING_PAGE_ALIAS_SUCCEEDED, DELETING_PAGE_ALIAS_FAILED,
INVALIDATE_ALIASES,
} from 'constants/actionTypes';

import { put, call, takeEvery } from '@redux-saga/core/effects';
import { createAction } from 'redux-actions';
import axios from 'axios';
import buildUrl from 'build-url';
import _ from 'lodash';

const apiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
const ALIAS_URL = `${apiUrl}/api/2.0/aliases`;

/**
 * Create page alias for {id}
*/
export const createPageAliases = createAction(CREATE_PAGE_ALIAS_REQUEST, (request) => {
  return {
    request: request,
  }
})

export const createPageAliasSucceeded = createAction(CREATING_PAGE_ALIAS_SUCCEEDED, (response) => {
  return {
    response: response
  };
})

export const createPageAliasFailed = createAction(CREATING_PAGE_ALIAS_FAILED, (error) => {
  return error;
})

function* createPageAliasSaga(action) {
  const { request } = action.payload;

  const createPageAliasAPI = () => {
    return axios.post(ALIAS_URL, request).then(response => response.data);
  }

  try {
    const response = yield call(createPageAliasAPI);
    if (response) {
      yield put(createPageAliasSucceeded(response));
    }
  } catch (error) {
    yield put(createPageAliasFailed(error));
  }
}

/**
 * Fetch page alias for {id}
*/
export const fetchPageAliases = createAction(FETCH_PAGE_ALIAS_REQUEST, (request, page, limit = 20) => {
  return {
    request: request,
    page: page,
    limit: limit
  }
})

export const fetchPageAliasSucceeded = createAction(FETCHING_PAGE_ALIAS_SUCCEEDED, (response) => {
  return {
    response: response
  };
})

export const fetchPageAliasFailed = createAction(FETCHING_PAGE_ALIAS_FAILED, (error) => {
  return error;
})

function* fetchPageAliasSaga(action) {
  const { request, page, limit } = action.payload;


  let url = buildUrl(ALIAS_URL, {
    path: `all?page=${page}&limit=${limit}`
  });

  const fetchPageAliasAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchPageAliasAPI);
    if (response) {
      yield put(fetchPageAliasSucceeded(response));
    }
  } catch (error) {
    yield put(fetchPageAliasFailed(error));
  }
}


/**
 * Update page alias for {id}
*/
export const updatePageAliases = createAction(UPDATE_PAGE_ALIAS_REQUEST, (id, request) => {
  return {
    id: id,
    request: request,
  }
})

export const updatePageAliasSucceeded = createAction(UPDATING_PAGE_ALIAS_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  };
})

export const updatePageAliasFailed = createAction(UPDATING_PAGE_ALIAS_FAILED, (error) => {
  return error;
})

function* updatePageAliasSage(action) {
  const { id, request } = action.payload;


  let url = buildUrl(ALIAS_URL, {
    path: `${id}`
  });

  const updatePageAliasAPI = () => {
    return axios.put(url, request).then(response => response.data);
  }

  try {
    const response = yield call(updatePageAliasAPI);
    if (response) {
      yield put(updatePageAliasSucceeded(id, response));
    }
  } catch (error) {
    yield put(updatePageAliasFailed(error));
  }
}

/**
 * Delete page Alias for {id}
*/
export const deletePageAlias = createAction(DELETE_PAGE_ALIAS_REQUEST, (id,   request) => {
  return {
    id: id,
    request: request
  };
});

const deletePageAliasSucceeded = createAction(DELETING_PAGE_ALIAS_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
});

const deletePageAliasFailed = createAction(DELETING_PAGE_ALIAS_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
});


function* deletePageAliasSaga(action) {
  const { id, request } = action.payload;

  let url = buildUrl(ALIAS_URL, {
    path: id
  });

  const deletePageAliasAPI = () => {
    return axios.delete(url, request).then(response => response.data);
  }

  try {
    const response = yield call(deletePageAliasAPI);
    yield put(deletePageAliasSucceeded(id, response));
  } catch (error) {
    yield put(deletePageAliasFailed(id, error));
  }
}

export const invalidateAliases = createAction(INVALIDATE_ALIASES);

export default function* aliasesSaga() {
  yield takeEvery(FETCH_PAGE_ALIAS_REQUEST, fetchPageAliasSaga);
  yield takeEvery(UPDATE_PAGE_ALIAS_REQUEST, updatePageAliasSage);
  yield takeEvery(DELETE_PAGE_ALIAS_REQUEST, deletePageAliasSaga);
  yield takeEvery(CREATE_PAGE_ALIAS_REQUEST, createPageAliasSaga);
}